import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ApPersistenceService } from '@ap/persistence';
import { ApTabComponent } from '@ap/tabs';
import { ApThemeService } from '@ap/theme';

import { MijnTemplateAnalyticsService } from '../analytics/analytics.service';
import content from '../mijn-template.content.json';

/**
 * @ngdoc component
 * @name MijnLoginTemplateComponent
 * @module MijnLoginTemplateModule
 */
@Component({
    selector: 'mijn-login-template',
    templateUrl: './mijn-login-template.component.html',
    styleUrls: ['./mijn-login-template.component.scss'],
    standalone: false
})
export class MijnLoginTemplateComponent implements OnInit {
    @ViewChildren(ApTabComponent) tabs: ApTabComponent[];

    @Input()
    public title: string;

    @Input()
    public showExtraContentCard = true;

    @Output()
    public bankSelected: EventEmitter<string> = new EventEmitter<string>();

    public displayEndorsement = false;
    public showMultipleTabs = false;
    public showNotification: boolean;

    multibankNotification = 'multitab-notification';

    public constructor(
        private readonly contentService: ApContentService,
        private readonly themeService: ApThemeService,
        private readonly persistenceService: ApPersistenceService,
        private readonly analyticsService: MijnTemplateAnalyticsService
    ) {}

    public ngOnInit(): void {
        this.displayEndorsement = ['reb', 'blg'].includes(this.themeService.getTheme());
        this.showMultipleTabs = ['asn'].includes(this.themeService.getTheme());
        this.contentService.addContentItems(content);

        const existingNotificationState = this.persistenceService.getLocal(this.multibankNotification, this.multibankNotification);
        if (existingNotificationState === null || existingNotificationState === undefined) {
            this.persistenceService.setLocal(this.multibankNotification, this.multibankNotification, true);
        }

        this.showNotification = this.persistenceService.getLocal(this.multibankNotification, this.multibankNotification);
    }

    public changedTab(event: string): void {
        if (this.tabs?.length) {
            const tab = this.tabs.find((x) => x.id() === event);
            if (tab) {
                const titleById = tab.title();
                this.analyticsService.clickEvent('Tab', titleById);
            }
        }
    }

    public navigateToSns(): void {
        this.navigateToBank('sns');
    }

    public navigateToReb(): void {
        this.navigateToBank('reb');
    }

    public navigateToBlg(): void {
        this.navigateToBank('blg');
    }

    public dismissNotification(): void {
        this.persistenceService.setLocal(this.multibankNotification, this.multibankNotification, false);
        this.showNotification = false;
    }

    private navigateToBank(bankType: 'sns' | 'reb' | 'blg'): void {
        const linkKey = `mijn.login.multibank.tab.${bankType}.link`;
        const bankLink = this.contentService.get(linkKey);

        this.analyticsService.clickEvent('Button', this.contentService.get(`mijn.login.multibank.tab.${bankType}.button`));

        if (bankLink) {
            window.open(bankLink, '_blank', 'noopener,noreferrer');
        }
    }
}
